import GeneralProjectTeamInfo from '../GeneralProjectTeamInfo';
import { useShowContext } from 'framework/show';
import { useFormShowContext } from 'framework/form';
import {
  TeamShowType,
  CreateProjectTeam,
  ProjectCriticalPeriodsLayout,
  ProjectPlannedLeavesLayout,
  ProjectTeamListLayout,
} from 'domain/shared/newProject';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import { UpcomingChangesLayout } from 'domain/shared/upcomingChanges';
import { ProjectTeamHeatmapSection } from 'domain/shared/projectHeatmap';
import ProjectPoliciesSection from '../ProjectPoliciesSection';
import { getProjectManager, useProjectDataContext } from 'domain/shared/newProject';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAsyncValue } from 'framework/utils';

const ProjectTeamContentWrapper = () => {
  const { isFeatureEnabled } = useFeatureToggle();
  const { isEditMode } = useFormShowContext();
  const { data } = useShowContext<TeamShowType>();
  const { data: project } = useProjectDataContext();
  const { getUserAlias } = useAuthenticatedUserService();
  const currentUserAlias = useAsyncValue(() => getUserAlias());
  const projectManagerAlias = getProjectManager(project);
  const { isNeedCreateTeam } = data.getData();
  const isProjectManager = !!currentUserAlias && !!projectManagerAlias && currentUserAlias === projectManagerAlias;

  return isEditMode && isNeedCreateTeam ? (
    <CreateProjectTeam />
  ) : (
    <>
      <GeneralProjectTeamInfo />
      <ProjectTeamListLayout />
      {isFeatureEnabled(Features.PROJECT_POLICIES_TEAM) && isProjectManager && <ProjectPoliciesSection />}
      {isFeatureEnabled(Features.STAFFING_HEATMAP) && <ProjectTeamHeatmapSection />}
      {isFeatureEnabled(Features.PROJECT_PLANNED_LEAVES_TEAM) && <ProjectPlannedLeavesLayout />}
      {isFeatureEnabled(Features.PROJECT_CRITICAL_PERIODS_TEAM) && <ProjectCriticalPeriodsLayout />}
      {isFeatureEnabled(Features.PROJECT_UPCOMING_CHANGES_TEAM) && <UpcomingChangesLayout />}
    </>
  );
};

export default ProjectTeamContentWrapper;
